import { render, staticRenderFns } from "./no-captcha.vue?vue&type=template&id=0bd9cf71&"
import script from "./no-captcha.vue?vue&type=script&lang=js&"
export * from "./no-captcha.vue?vue&type=script&lang=js&"
import style0 from "./no-captcha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports